import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { CheckCircle2, ArrowRight } from 'lucide-react';

export const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20">
      <div className="absolute inset-0 bg-gradient-to-b from-muted/50 to-background -z-10"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <Badge className="bg-secondary/10 text-secondary border-secondary/30 hover:bg-secondary/20">
              <CheckCircle2 className="w-3 h-3 mr-1" />
              Kantonal bewilligt
            </Badge>
            
            <div className="space-y-4">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Professionelle
                <span className="block text-primary">Reifenentsorgung</span>
                & Großhandel
              </h1>
              
              <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-xl">
                Ihr zuverlässiger Partner für nachhaltige Reifenentsorgung und Grosshandel in Reifen & Felgen aller Art. Kantonal bewilligt und umweltfreundlich.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg" 
                className="bg-primary hover:bg-primary/90 text-primary-foreground text-base group"
                onClick={scrollToContact}
              >
                Jetzt Kontakt aufnehmen
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground text-base"
                onClick={() => {
                  const element = document.getElementById('services');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Unsere Dienstleistungen
              </Button>
            </div>

            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-border">
              <div>
                <p className="text-3xl font-bold text-primary" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>100%</p>
                <p className="text-sm text-muted-foreground mt-1">Umweltfreundlich</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-primary" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>24/7</p>
                <p className="text-sm text-muted-foreground mt-1">Verfügbar</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-primary" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>10+</p>
                <p className="text-sm text-muted-foreground mt-1">Jahre Erfahrung</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="/images/international-recycling.webp" 
                alt="Pneu-Idris - Umweltfreundliche Reifenentsorgung mit globalem Recycling" 
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/30 to-transparent"></div>
            </div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-secondary rounded-full blur-3xl opacity-30"></div>
            <div className="absolute -top-6 -right-6 w-40 h-40 bg-primary rounded-full blur-3xl opacity-20"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
